<template>
    <v-container fluid>
        <v-row no-gutters justify="center">
            <v-col cols="8">
                <v-row dense>
                    <v-col cols="12">
                        <v-btn small color="grey lighten-2" v-on:click.prevent="print">Print</v-btn>
                    </v-col>
                </v-row>

                <div id="invoiceContent">
                    <div class="custom-row">
                        <div class="invoice-title">
                        Cash Transaction
                        </div>
                    </div>
                    <div class="custom-row">
                        <div class="col-xs-6">
                            <table class="table">
                                
                                <tr>
                                    <td>Trans. Date</td>
                                    <td>:</td>
                                    <td>{{ transaction.transaction_date }}</td>
                                </tr>
                                <tr>
                                    <td>Account Name</td>
                                    <td>:</td>
                                    <td>{{ transaction.transaction_account.account_name }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-xs-6">
                            <table class="table" style="float:right">
                               <tr>
                                    <td>Trans. Id</td>
                                    <td>:</td>
                                    <td>{{ transaction.code }}</td>
                                </tr>
                            </table>
                        </div>


                        <div class="cls"></div>
                    </div>
                    <div class="custom-row" style="margin-top:15px">
                        <div class="col-xs-12">
                            <table class="invoice-details" border="1px solid #ccc;">
                                <thead>
                                    <tr>
                                        <td>Sl No.</td>
                                        <td colspan="2" width="50%">Description</td>
                                        <td>Recieved</td>
                                        <td>Paid</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center">1</td>
                                        <td colspan="2">{{ transaction.description }}</td>
                                        <td class="text-right">{{ transaction.received_amount }}</td>
                                        <td class="text-right">{{ transaction.paid_amount }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="text-right"><strong>Total</strong></td>
                                        <td class="text-right"><strong>{{ transaction.received_amount }}</strong></td>
                                        <td class="text-right"><strong>{{ transaction.paid_amount }}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="custom-row">
                        <div class="col-xs-6">
                            <p class="mt-60">
                                <span style="text-decoration:overline;font-weight:500;font-size:14px;font-family: emoji;">Received By</span>
                            </p>
                        </div>
                        <div class="col-xs-6">
                            <div class="mt-60">
                                <p class="text-right">
                                    <span style="text-decoration:overline;font-weight:500;font-size:14px;font-family: emoji;">Authorized Signature</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div> 

            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'TransactionInvoice',
    data: ()=> ({
        transaction: {
            transaction_account: {}
        }
    }),
    async created() {
        await this.$store.dispatch('cashTransaction/getCashTransactions', {id: this.$route.params.id})
        this.transaction = await this.$store.getters['cashTransaction/cashTransactions'][0];

        this.$store.dispatch('companyProfile/getCompanyProfile')

        this.setStyle();
    },
    methods: {
        async print(){
            let invoiceContent = document.querySelector('#invoiceContent').innerHTML;
            let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`);
            let ImagePath = this.apiBasePath +`/`+ this.$store.getters['companyProfile/company'].image;
            let companyName = this.$store.getters['companyProfile/company'].company_name;
            let address = this.$store.getters['companyProfile/company'].address;
            let contactUs = this.$store.getters['companyProfile/company'].contact_us;
            let email = this.$store.getters['companyProfile/company'].email;
            printWindow.document.write(`
                <!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <meta http-equiv="X-UA-Compatible" content="ie=edge">
                    <title>Investigation Payment Slip</title>
                    <style>
                    </style>
                </head>
                <body>
                    <div>
                        <div class="container">
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <td>
                                            <div class="custom-row">
                                                <div class="col-xs-2">
                                                    <img src="`+ImagePath+`" alt="Logo" style="height:90px; width:90%;object-fit: contain;" />
                                                </div>
                                                <div class="col-xs-10">
                                                    <strong style="font-size:18px;">${companyName}</strong><br>
                                                    <p style="white-space:pre-line;margin:0px">Address : ${address}</p>
                                                    <p style="margin:0px">Mobile : ${contactUs}</p>
                                                    <p style="margin:0px">E-mail : ${email}</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div class="custom-row">
                                                <div class="col-xs-12">
                                                    ${invoiceContent}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>
                                            <div style="width:100%;height:50px;">&nbsp;</div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>    
                    
                </body>
                </html>
            `);
            
            let invoiceStyle = printWindow.document.createElement('style');
            invoiceStyle.innerHTML = this.style.innerHTML;
            printWindow.document.head.appendChild(invoiceStyle);
            printWindow.moveTo(0, 0);
            
            printWindow.focus();
            await new Promise(resolve => setTimeout(resolve, 1000));
            printWindow.print();
            printWindow.close();
        },
        setStyle(){
            this.style = document.createElement('style');
            this.style.innerHTML = `
                .custom-row {
                    width: 100%;
                    display: block;
                }
                .print-btn a{
                    background: #CFD8DC;
                    display: inline-block;
                    padding: 3px 13px;
                    border-radius: 5px;
                    color: #000 !important;
                }
                .print-btn a:hover {
                    background: #B0BEC5;
                }
                .invoice-title {
                    text-align: center;
                    font-weight: bold;
                    font-size: 15px;
                    margin-bottom: 15px;
                    padding: 5px;
                    border-top: 1px dotted #454545;
                    border-bottom: 1px dotted #454545;
                }
                .col-xs-12 {
                    width: 100%;
                }
                .col-xs-10 {
                    width: 80%;
                    float: left;
                }
                .col-xs-9 {
                    width: 70%;
                    float: left;
                }
                .col-xs-7 {
                    width: 60%;
                    float: left;
                }
                .col-xs-6 {
                    width: 50%;
                    float: left;
                }
                .col-xs-5 {
                    width: 40%;
                    float: left;
                }
                .col-xs-4 {
                    width: 35%;
                    float: left;
                }
                .col-xs-3 {
                    width: 30%;
                    float: left;
                }
                .col-xs-2 {
                    width: 20%;
                    float: left;
                }
                .b-text {
                    font-weight: 500;
                    font-size: 15px;
                }
                .normal-text {
                    font-size: 14px;
                    margin: 0px;
                }
                .invoice-details {
                    width: 100%;
                    border-collapse: collapse;
                    border:1px solid #ccc;
                }
                .invoice-details thead {
                    font-weight: 600;
                    text-align:center;
                    font-family: emoji;
                }
                .invoice-details tbody td{
                    padding: 0px 5px;
                    font-family: emoji;
                }
                .text-center {
                    text-align: center;
                }
                .text-right {
                    text-align: right;
                }
                .line {
                    border-bottom: 1px solid #ccc;
                    margin-top: 15px;
                    margin-bottom: 15px;
                }
                .paid-text {
                    padding:30px 0px;
                }
                .mt-60 {
                    margin-top: 60px;
                }
                .mr-20 {
                    margin-right: 20px;
                }
                .ml-20 {
                    margin-left: 20px;
                }
                .ft-fiext {
                    position: fixed;
                    bottom: 0;
                }
                .cls {
                    clear: both;
                }
            `;
            document.head.appendChild(this.style);
        },
    }
}
</script>

<style lang="scss" scoped>
    .table tr td:first-child {
        font-weight: bold;
        padding-right: 5px;
        font-family: emoji;
    }
    .table tr td:last-child {
        padding-left: 5px;
        font-family: emoji;
    }
    
</style>
